import React from 'react';
import '../components/CalculusOfMeaning.css';

function GnulPage() {
  return (
    <div className="calculus-page">
      <div className="calculus-hero">
        <div className="calculus-hero-overlay" style={{ background: 'linear-gradient(to bottom, rgba(8,8,8,0.5) 0%, rgba(8,8,8,0.8) 60%, rgba(8,8,8,1) 100%)' }} />
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundImage: 'url(/assets/gnul-hero.png)', backgroundSize: 'cover', backgroundPosition: 'center 20%', zIndex: 1 }} />
        <div className="calculus-hero-content">
          <span className="calculus-hero-label">A Narrative Physics&trade; Leadership Program</span>
          <h1>Gnul</h1>
          <p className="calculus-hero-sub">A Half-Orc raised by a biochemist walks into a world that has never seen him. Every lesson is a moment. Every moment is chemistry.</p>
        </div>
      </div>

      <div className="calculus-body" style={{ backgroundImage: 'url(/assets/calculus-bg.png)' }}>
        <div className="calculus-content">

          <section className="calc-section reveal" style={{ textAlign: 'center', padding: '3rem 0' }}>
            <h2>The Chemistry of Leadership</h2>
            <p style={{ fontSize: '1.3rem', color: '#c9a84c', marginBottom: '2rem' }}>
              What if the most powerful leader in the room was the one who understood
              the neurochemistry of every person in it?
            </p>
            <p>
              Gnul has never met another being besides his caretaker. She raised him on
              biochemistry, pharmacokinetics, and the science of how his appearance
              affects every nervous system in the room. She gave him every tool.
            </p>
            <p>
              Then she kicked him out of the nest.
            </p>
          </section>

          <div className="calc-divider"><div className="calc-line" /></div>

          <section className="calc-section reveal">
            <h2>Chapters</h2>
            <div style={{ display: 'grid', gap: '1.5rem', marginTop: '1.5rem' }}>
              <a href="/gnul/chapter-1" style={{ display: 'block', background: 'rgba(201,168,76,0.08)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: '12px', padding: '1.5rem', textDecoration: 'none', color: '#fff', transition: 'all 0.3s' }}>
                <h3 style={{ color: '#c9a84c', margin: '0 0 0.5rem' }}>Chapter 1: The Notification</h3>
                <p style={{ color: '#aaa', margin: 0 }}>A phone he has never held. A company that has never seen him. And a letter that says everything in two words.</p>
              </a>
              <a href="/gnul/chapter-2" style={{ display: 'block', background: 'rgba(201,168,76,0.08)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: '12px', padding: '1.5rem', textDecoration: 'none', color: '#fff', transition: 'all 0.3s' }}>
                <h3 style={{ color: '#c9a84c', margin: '0 0 0.5rem' }}>Chapter 2: The Terminal</h3>
                <p style={{ color: '#aaa', margin: 0 }}>Four hundred nervous systems. One scream. And the moment he learned the difference between knowing the math and being the variable.</p>
              </a>
              <a href="/gnul/chapter-3" style={{ display: 'block', background: 'rgba(201,168,76,0.08)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: '12px', padding: '1.5rem', textDecoration: 'none', color: '#fff', transition: 'all 0.3s' }}>
                <h3 style={{ color: '#c9a84c', margin: '0 0 0.5rem' }}>Chapter 3: The Landing</h3>
                <p style={{ color: '#aaa', margin: 0 }}>A phone call changes everything. A Chief of Staff shows his hand. And Loriann booked the jet.</p>
              </a>
              <a href="/gnul/chapter-4" style={{ display: 'block', background: 'rgba(201,168,76,0.08)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: '12px', padding: '1.5rem', textDecoration: 'none', color: '#fff', transition: 'all 0.3s' }}>
                <h3 style={{ color: '#c9a84c', margin: '0 0 0.5rem' }}>Chapter 4: The Meridian</h3>
                <p style={{ color: '#aaa', margin: 0 }}>The body cannot process what the mind has not yet accepted. A quiet room. A meal that looks like home. And the suit that buys him 200 milliseconds.</p>
              </a>
              <a href="/gnul/chapter-5" style={{ display: 'block', background: 'rgba(201,168,76,0.08)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: '12px', padding: '1.5rem', textDecoration: 'none', color: '#fff', transition: 'all 0.3s' }}>
                <h3 style={{ color: '#c9a84c', margin: '0 0 0.5rem' }}>Chapter 5: The Lobby</h3>
                <p style={{ color: '#aaa', margin: 0 }}>Nine people in wrinkled clothes. One word that released a man's shoulders. And a plate of food that no one arranged.</p>
              </a>
              <a href="/gnul/chapter-6" style={{ display: 'block', background: 'rgba(201,168,76,0.08)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: '12px', padding: '1.5rem', textDecoration: 'none', color: '#fff', transition: 'all 0.3s' }}>
                <h3 style={{ color: '#c9a84c', margin: '0 0 0.5rem' }}>Chapter 6: The Slide Deck</h3>
                <p style={{ color: '#aaa', margin: 0 }}>42 slides. 38 minutes. One question from the back row. And a company that will never hear the word "alignment" the same way again.</p>
              </a>
              <a href="/gnul/chapter-7" style={{ display: 'block', background: 'rgba(201,168,76,0.08)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: '12px', padding: '1.5rem', textDecoration: 'none', color: '#fff', transition: 'all 0.3s' }}>
                <h3 style={{ color: '#c9a84c', margin: '0 0 0.5rem' }}>Chapter 7: The Bill</h3>
                <p style={{ color: '#aaa', margin: 0 }}>Fear is free to deploy and expensive to clean up. Gnul feeds four hundred people and asks Voss one question: how much money do you have?</p>
              </a>
              <a href="/gnul/chapter-8" style={{ display: 'block', background: 'rgba(201,168,76,0.08)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: '12px', padding: '1.5rem', textDecoration: 'none', color: '#fff', transition: 'all 0.3s' }}>
                <h3 style={{ color: '#c9a84c', margin: '0 0 0.5rem' }}>Chapter 8: The Empty Building</h3>
                <p style={{ color: '#aaa', margin: 0 }}>He gave them the day off. Sixty-three showed up anyway. The Voss buffer. And the rosemary thread pulls tighter.</p>
              </a>
              <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '12px', padding: '1.5rem', opacity: 0.5 }}>
                <h3 style={{ color: '#666', margin: '0 0 0.5rem' }}>Chapter 9: Coming Soon</h3>
                <p style={{ color: '#555', margin: 0 }}>The connection. The caretaker. And the truth about Seraphine Vael.</p>
              </div>
            </div>
          </section>

          <div className="calc-divider"><div className="calc-line" /></div>

          <div className="calc-signature reveal">
            <p><strong>Nexus Concordat Inc.</strong></p>
            <p>Narrative Physics&trade; Leadership Development</p>
            <div className="patent-tags">
              <span className="patent-tag">Patent Pending: 63/939,190</span>
              <span className="patent-tag">Patent Pending: 63/962,385</span>
              <span className="patent-tag">Patent Pending: 63/988,485</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default GnulPage;
